// タスク詳細 Notes に添付する画像の検証・パス生成ヘルパ。
// 保存形式や制約は docs/superpowers/specs/2026-07-20-task-notes-image-attach-design.md を参照。

export const TASK_IMAGE_MAX_BYTES = 10 * 1024 * 1024; // 10MB

// MIME タイプ → ストレージ上の拡張子
export const TASK_IMAGE_ACCEPTED_TYPES: Record<string, string> = {
  "image/png": "png",
  "image/jpeg": "jpg",
  "image/gif": "gif",
  "image/webp": "webp",
};

export type TaskImageValidation =
  | { ok: true; ext: string }
  | { ok: false; reason: "type" | "size" };

export function validateTaskImageFile(file: { type: string; size: number }): TaskImageValidation {
  const ext = TASK_IMAGE_ACCEPTED_TYPES[file.type];
  if (!ext) return { ok: false, reason: "type" };
  if (file.size > TASK_IMAGE_MAX_BYTES) return { ok: false, reason: "size" };
  return { ok: true, ext };
}

/** task-images バケット内のオブジェクトパスを生成する（RLS がパス先頭の notebookId を判定する）。 */
export function buildTaskImagePath(notebookId: string, lineId: string, ext: string): string {
  return `${notebookId}/${lineId}/${crypto.randomUUID()}.${ext}`;
}

/**
 * メモ画像のオブジェクトパスを生成する。
 * メモは本人のみアクセス (RLS が memo/<userId>/ プレフィックスを判定する)。
 * ノートブック紐付けは後から変更/解除されるため notebookId は使わない。
 */
export function buildMemoImagePath(userId: string, memoId: string, ext: string): string {
  return `memo/${userId}/${memoId}/${crypto.randomUUID()}.${ext}`;
}

/** src が外部 URL（署名解決せずそのまま表示するもの）かどうか。 */
export function isExternalImageSrc(src: string): boolean {
  return /^https?:\/\//i.test(src) || src.startsWith("data:");
}
